import CloseIcon from "assets/icons/closeIcon.svg"
import { buttonFocus } from "shared/styles/mixins"
import styled, { css } from "styled-components"

type ButtonProps = {
  size?: number
  $showHoverStyles?: boolean
}

export const StyledCloseButton = styled.button.attrs({
  type: "button",
})<ButtonProps>`
  border: none;
  background-color: transparent;
  padding: 5px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: ${(props) => props.size || 17}px;
    height: ${(props) => props.size || 17}px;
    stroke: ${(props) => props.theme.colors.med};
    stroke-width: 2px;

    @media (hover: hover) {
      ${(props) =>
        props.$showHoverStyles &&
        css`
          &:hover {
            stroke-width: 3px;
          }
        `}
    }
  }

  ${buttonFocus}
`

export type CloseButtonProps = {
  size?: number
  onClose: () => void
  showHoverStyles?: boolean
  robotTag?: string // unique tag for testing library to select this button
}

const CloseButton = ({
  onClose = () => {},
  size,
  showHoverStyles = false,
  robotTag,
}: CloseButtonProps) => (
  <StyledCloseButton
    $showHoverStyles={showHoverStyles}
    aria-label="Close"
    onClick={onClose}
    size={size}
    data-robot={robotTag ?? "close-button"}
  >
    <CloseIcon />
  </StyledCloseButton>
)

export default CloseButton
